<template>
  <div>
    <v-card>
      <v-card-text>
        <h3>Pick image :</h3>
        <ImagesCarusel
          v-bind="caruselProps"
          :chunkArray="chunkImagesArray"
          @selected="onClickHandler"
        ></ImagesCarusel>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import httpClient from '@/api/httpClient'
import ImageCard from '@/components/images/ImageCard'
import ImagesCarusel from '@/components/images/ImagesCarusel'
export default {
  data() {
    return {
      response: null,
      imagesToPreview: null,
      content: null,
      selectedImages: null
    }
  },
  provide: function() {
    return {
      imgProps: this.imgProps
    }
  },
  components: {
    ImageCard,
    ImagesCarusel
  },
  created() {
    this.getAllImages()
  },
  methods: {
    async getAllImages() {
      await httpClient
        .get(this.areaProps.endPoint)
        .then(response => {
          this.response = response.data
        })
        .then(() => {
          this.addPathAndStatusToImgFile()
        })
        .then(() => {
          this.imagesToPreview = this.response
        })
        .then(() => {
          if (this.selectedImagesId) {
            this.setSelectedImages(this.selectedImagesId)
          }
        })
        .then(() => {
          this.makeChunkImagesArray()
        })
    },
    onClickHandler(id) {
      let selected = this.imagesToPreview.find(el => el.id == id)
      //MULTIPLE
      if (this.areaProps.multiple) {
        //Proverava da li ima preselektovanih slika
        this.selectedImagesId
          ? (this.content = this.selectedImagesId)
          : (this.content = [])
        if (!selected.status) {
          Object.assign(selected, { status: true })
          this.content.push(id)
          //Dodavanje jedinstvenih id-a u niz
          this.content = [...new Set(this.content)]
        } else {
          Object.assign(selected, { status: false })
          //Brisanje iz niza
          this.content = this.content.filter(el => el !== id)
        }
        this.imagesToPreview
          .filter(e => e.id === selected.id)
          .map(el => (el = selected))
      } else {
        //SINGLE UPLOAD
        if (!selected.status) {
          selected = Object.assign({}, selected, { status: true })
          this.imagesToPreview.map(el => (el.status = false))
          this.imagesToPreview
            .filter(e => e.id == id)
            .map(el => (el.status = selected.status))
          //Dodavanje jedinstvenih id-a u content
          this.content = selected.id
        } else {
          Object.assign(selected, { status: false })
          this.content = null
        }
      }
    },
    addPathAndStatusToImgFile() {
      for (const img of this.response) {
        let path =
          process.env.VUE_APP_S3_DOMAIN +
          '/' +
          this.areaProps.endPoint +
          '/' +
          img.fileName
        Object.assign(img, { imgPath: path })
        this.$set(img, 'status', false)
        // Object.assign(img, { status: false })
      }
    },
    makeChunkImagesArray: function() {
      const chunked_arr = []
      let index = 0
      while (index < this.imagesToPreview.length) {
        chunked_arr.push(
          this.imagesToPreview.slice(index, this.areaProps.chunkSize + index)
        )
        index += this.areaProps.chunkSize
      }
      return chunked_arr
    },
    setSelectedImages(selectedImagesId) {
      //!!! Testing for multiple useCase !!!
      //selectedImagesId = [3, 4]
      if (Array.isArray(selectedImagesId)) {
        for (const ids of selectedImagesId) {
          this.imagesToPreview
            .filter(el => el.id == ids)
            .map(e => (e.status = true))
        }
      } else {
        this.imagesToPreview
          .filter(el => el.id == selectedImagesId)
          .map(e => (e.status = true))
      }
    }
  },
  computed: {
    baseUrl: function() {
      return process.env.VUE_APP_BACKEND_URL
    },
    chunkImagesArray: function() {
      if (this.imagesToPreview) {
        return this.makeChunkImagesArray()
      }
      return []
    },
    areaProps: function() {
      return this.$attrs.areaProps
    },
    caruselProps: function() {
      return this.$attrs.caruselProps
    },
    imgProps: function() {
      return this.$attrs.imgProps
    },
    selectedImagesId: function() {
      return this.$attrs.value
    }
  },
  watch: {
    content: {
      async handler() {
        this.$emit('input', this.content)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
